import React from 'react';

import styles from './ChallengeEmptyState.module.scss';

interface ChallengeEmptyStateProps {
  text: string;
}

export const ChallengeEmptyState = ({ text }: ChallengeEmptyStateProps) => {
  return (
    <div className={styles.challengeEmptyStateWrapper}>
      <img alt="challenge-empty-icon" src="icons/challenge-cup.svg" />
      <div className={styles.challengeEmptyStateBody}>{text}</div>
    </div>
  );
};
